export default __webpack_public_path__ + "static/media/admin.1a794f54.svg";